import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { HookType } from '../enum/hooks.enum';
import { environment } from "../../environments/environment"
import { NgModelGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class WebhookService {

  constructor(private httpClient: HttpClient) { }
  getHookDetails(info: { applicationId: string, clientId: string }) {
    return this.httpClient.get(`${environment.serverUrl}utility/hooks/${info.clientId}/${info.applicationId}`);
  }
  saveHook(model: Array<{ url: string, active: boolean, type: HookType, application_id: String }>, info: { applicationId: string, clientId: string }) {
    return this.httpClient.post(`${environment.serverUrl}utility/hooks/${info.clientId}/${info.applicationId}`, model);
  }
  updateHook(model: {
    webHook: Array<{ url: string, active: boolean, type: HookType, application_id: String }>,
    permissionWebHook: Partial<{ _id: string, url: string, active: boolean, application_id: string }>
  }, info: { applicationId: string, clientId: string }) {
    return this.httpClient.put(`${environment.serverUrl}utility/hooks/${info.clientId}/${info.applicationId}`, model);
  }
  testHook(model: { url: string, active: boolean, type: HookType }) {
    return this.httpClient.post(`${environment.serverUrl}utility/test-hook`, model);
  }
}
